import React, { useState } from "react";
import "../../assets/css/tables.css";
import Swal from "sweetalert2";
import deletes from "../../assets/images/tablesImg/delete.png";
import flash from "../../assets/images/courses/Flashcard.svg";
import more_vert from "../../assets/images/home/more_vert.png";
import { useHistory } from "react-router-dom";
import Repository from "../../configs/axios/repository";
import { handleGetFlashcard } from "../../redux/layout";
import { useDispatch } from "react-redux";
import {
    UncontrolledDropdown,
    DropdownMenu,
    DropdownToggle,
    DropdownItem,
} from "reactstrap";
import { openFlashcard } from "../globalFunctions/openFlashcard";
const FlashTable = ({
    flashcard,
    refreshTable,
    setLoadingData,
    loadingData,
    noteData,
}) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const deleteFlashcard = async (flashId) => {
        const result = await Repository.deleteById(
            `api/flashcards/deleteFlashcard/${flashId}`
        );
        if (result.data?.success == true) {
            refreshTable();
            loadingData
                ? Swal.fire(
                      "Deleted!",
                      "Your file has been deleted.",
                      "success"
                  )
                : "";
        }
    };

    function handleDelete(id) {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoadingData(false);
                deleteFlashcard(id);
            }
            setLoadingData(true);
        });
    }

 

    const thumbs = flashcard.map((file, i) => {
        return (
            <div key={i}>
                <div
                    className="parentCoursesDiv"
                    onClick={(e) => {
                        openFlashcard(dispatch, history, file, handleGetFlashcard, noteData);
                    }}
                >
                    <div className="clidrenDivCompakt">
                        <div>
                            <img src={flash} alt="testPng" />
                        </div>
                        <div className="">
                            <span>{file.flashcard_name}</span>
                            {/* <p>Lorem ipsum...</p> */}
                        </div>
                    </div>
                </div>
                <div className="parentDelete ">
                    <div className="childDiv">
                        <div>
                            <UncontrolledDropdown className="dropdown-user nav-item actionContent">
                                <DropdownToggle
                                    tag="a"
                                    className="nav-link dropdown-user-link pointsInTeam pointDiv"
                                >
                                    <img src={more_vert} alt="points" />
                                </DropdownToggle>
                                <DropdownMenu
                                    end
                                    id="pointDropdownFlash"
                                    className="dropMenu"
                                >
                                    <DropdownItem
                                        onClick={(e) => {
                                            handleDelete(file.flashcard_id);
                                        }}
                                    >
                                        <div className="actionsMenu">
                                            <img src={deletes} alt="deletes" />
                                            <span>Delete</span>
                                        </div>
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                    </div>
                </div>
            </div>
        );
    });
    return <div className="divTable mt-2">{thumbs}</div>;
};

export default FlashTable;
